export const CURRENT_PRICE_TEXT = (useLockPriceLanguage?: boolean) =>
  `Current price to be ${useLockPriceLanguage ? "locked" : "frozen"}:`;
export const ROUND_TRIP_TEXT = "Round-trip";
export const ONE_WAY_TEXT = "One-way";
export const CONNECTOR = ", ";
export const PER_TRAVELER_TEXT = "per traveler";
export const DEPARTURE_FLIGHT_HEADER = "Lowest-priced <b>outbound</b> flight";
export const RETURN_FLIGHT_HEADER = "Lowest-priced <b>return</b> flight";
